module.exports = __webpack_public_path__ + "img/sub-banner-auth.34802d3f.svg";